import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from "react-redux";

const RoleGuard = ({ allowedRoles = [] }) => {
  const { token, profile } = useSelector((state) => state.auth);
  let roleslist = profile && profile?.roles ? profile?.roles.map(role => role.name) : [];
  if (!token) return <Navigate to="/Login" replace />;
  if (!roleslist.includes(allowedRoles[0])) return <Navigate to="/NotAuthorised" replace />;

  return <Outlet />;
};

export default RoleGuard;